import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "section-text" }, "Información representación legal", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "pep-text" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "section-text" }, "*PEP"),
  /*#__PURE__*/_createTextVNode(" es la Persona Expuesta Políticamente, iIgualmente se catalogan como PEP las personas que tengan una sociedad conyugal, de hecho, o derecho con las personas expuestas políticamente nacionales o extranjeras, así como a sus familiares hasta el segundo grado de consanguinidad, segundo de afinidad y primero civil. ")
], -1)
const _hoisted_3 = { class: "highlightedTextLegal" }
const _hoisted_4 = { class: "highlightedTextLegal" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "section-text" }, "Representantes legales principales", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"62px"} }, null, -1)
const _hoisted_7 = { style: {"height":"62px"} }
const _hoisted_8 = { style: {"height":"62px"} }
const _hoisted_9 = { style: {"height":"62px"} }
const _hoisted_10 = { style: {"height":"62px"} }
const _hoisted_11 = { style: {"height":"62px"} }
const _hoisted_12 = { style: {"height":"62px"} }
const _hoisted_13 = { style: {"height":"62px"} }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"62px"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_3, [
                _createElementVNode("b", null, [
                  _createTextVNode("En caso de que las filas no sean suficientes, agrega más filas en \" "),
                  _createVNode(_component_el_button, {
                    circle: "",
                    class: "dinamic-form-button",
                    size: "mini",
                    type: "success ",
                    icon: "el-icon-plus"
                  }),
                  _createTextVNode(" \" ")
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_4, [
                _createElementVNode("b", null, [
                  _createTextVNode("En caso de requerir eliminar alguna fila, da clic en \" "),
                  _createVNode(_component_el_button, {
                    circle: "",
                    class: "dinamic-form-button",
                    size: "mini",
                    type: "success ",
                    icon: "el-icon-minus"
                  }),
                  _createTextVNode(" \" ")
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 22 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table, {
                height: "300",
                data: _ctx.objetoInfoRepresentanteTitular.RLTitular,
                span: 24,
                "header-align": "left"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, { width: "20%" }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("span", null, [
                        _createElementVNode("b", null, _toDisplayString(scope.$index + 1), 1)
                      ]),
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    class: "section-text-color",
                    label: "Nombre de representantes legales*",
                    width: "228px;"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_input, {
                        type: "text",
                        modelValue: scope.row.NombreRLTitular,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.NombreRLTitular) = $event),
                        class: _normalizeClass([_ctx.validacionInfoRepresentanteTitular.RLTitular.$each.$response.$errors[scope.$index].NombreRLTitular.length ? 'border-invalid' : 'border-valid'])
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                      _withDirectives(_createElementVNode("div", _hoisted_7, null, 512), [
                        [_vShow, !_ctx.validacionInfoRepresentanteTitular.RLTitular.$each.$response.$errors[scope.$index].NombreRLTitular.length]
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoRepresentanteTitular.RLTitular.$each.$response.$errors[scope.$index].NombreRLTitular, (error) => {
                        return (_openBlock(), _createBlock(_component_el_form_item, {
                          key: error,
                          class: "section-error-message"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(error.$message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Tipo ID*",
                    width: "140px;"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_select, {
                        modelValue: scope.row.TipoIdRLTitular,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.TipoIdRLTitular) = $event),
                        placeholder: "Seleccionar",
                        class: _normalizeClass([_ctx.validacionInfoRepresentanteTitular.RLTitular.$each.$response.$errors[scope.$index].TipoIdRLTitular.length ? 'border-invalid' : 'border-valid'])
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.tipoDeIdentificacion, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.codigo,
                              label: item.valor,
                              value: item.valor
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue", "class"]),
                      _withDirectives(_createElementVNode("div", _hoisted_8, null, 512), [
                        [_vShow, !_ctx.validacionInfoRepresentanteTitular.RLTitular.$each.$response.$errors[scope.$index].TipoIdRLTitular.length]
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoRepresentanteTitular.RLTitular.$each.$response.$errors[scope.$index].TipoIdRLTitular, (error) => {
                        return (_openBlock(), _createBlock(_component_el_form_item, {
                          key: error,
                          class: "section-error-message"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(error.$message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "N° ID*",
                    width: "150px;"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_input, {
                        type: "text",
                        modelValue: scope.row.NumeroIdentificacionRLTitular,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.NumeroIdentificacionRLTitular) = $event),
                        class: _normalizeClass([_ctx.validacionInfoRepresentanteTitular.RLTitular.$each.$response.$errors[scope.$index].NumeroIdentificacionRLTitular.length ? 'border-invalid' : 'border-valid'])
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                      _withDirectives(_createElementVNode("div", _hoisted_9, null, 512), [
                        [_vShow, !_ctx.validacionInfoRepresentanteTitular.RLTitular.$each.$response.$errors[scope.$index].NumeroIdentificacionRLTitular.length]
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoRepresentanteTitular.RLTitular.$each.$response.$errors[scope.$index].NumeroIdentificacionRLTitular, (error) => {
                        return (_openBlock(), _createBlock(_component_el_form_item, {
                          key: error,
                          class: "section-error-message"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(error.$message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Cargo en la empresa*",
                    width: "200px;"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_input, {
                        type: "text",
                        modelValue: scope.row.CargoEmpresaRLTitular,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.CargoEmpresaRLTitular) = $event),
                        class: _normalizeClass([_ctx.validacionInfoRepresentanteTitular.RLTitular.$each.$response.$errors[scope.$index].CargoEmpresaRLTitular.length ? 'border-invalid' : 'border-valid'])
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                      _withDirectives(_createElementVNode("div", _hoisted_10, null, 512), [
                        [_vShow, !_ctx.validacionInfoRepresentanteTitular.RLTitular.$each.$response.$errors[scope.$index].CargoEmpresaRLTitular.length]
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoRepresentanteTitular.RLTitular.$each.$response.$errors[scope.$index].CargoEmpresaRLTitular, (error) => {
                        return (_openBlock(), _createBlock(_component_el_form_item, {
                          key: error,
                          class: "section-error-message"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(error.$message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Correo electrónico (e-mail)",
                    width: "250px;"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_input, {
                        type: "text",
                        modelValue: scope.row.CorreoRLTitular,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.CorreoRLTitular) = $event),
                        class: _normalizeClass([_ctx.validacionInfoRepresentanteTitular.RLTitular.$each.$response.$errors[scope.$index].CorreoRLTitular.length ? 'border-invalid' : 'border-valid'])
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                      _withDirectives(_createElementVNode("div", _hoisted_11, null, 512), [
                        [_vShow, !_ctx.validacionInfoRepresentanteTitular.RLTitular.$each.$response.$errors[scope.$index].CorreoRLTitular.length]
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoRepresentanteTitular.RLTitular.$each.$response.$errors[scope.$index].CorreoRLTitular, (error) => {
                        return (_openBlock(), _createBlock(_component_el_form_item, {
                          key: error,
                          class: "section-error-message"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(error.$message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "¿Es PEP?*",
                    "class-name": "header_color",
                    width: "130px;"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_select, {
                        modelValue: scope.row.EsPEPRLTitular,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.EsPEPRLTitular) = $event),
                        placeholder: "Seleccionar",
                        class: _normalizeClass([_ctx.validacionInfoRepresentanteTitular.RLTitular.$each.$response.$errors[scope.$index].EsPEPRLTitular.length ? 'border-invalid' : 'border-valid']),
                        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ValidaSiPEP()))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.generico, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.codigo,
                              label: item.valor,
                              value: item.valor
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue", "class"]),
                      _withDirectives(_createElementVNode("div", _hoisted_12, null, 512), [
                        [_vShow, !_ctx.validacionInfoRepresentanteTitular.RLTitular.$each.$response.$errors[scope.$index].EsPEPRLTitular.length]
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoRepresentanteTitular.RLTitular.$each.$response.$errors[scope.$index].EsPEPRLTitular, (error) => {
                        return (_openBlock(), _createBlock(_component_el_form_item, {
                          key: error,
                          class: "section-error-message"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(error.$message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "¿Tiene vínculos familiares con PEP?*",
                    width: "170px;",
                    "class-name": "header_color"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_select, {
                        modelValue: scope.row.VinculosFamPEP_RLTitular,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.VinculosFamPEP_RLTitular) = $event),
                        placeholder: "Seleccionar",
                        class: _normalizeClass([_ctx.validacionInfoRepresentanteTitular.RLTitular.$each.$response.$errors[scope.$index].VinculosFamPEP_RLTitular.length ? 'border-invalid' : 'border-valid']),
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ValidaSiPEP()))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.generico, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.codigo,
                              label: item.valor,
                              value: item.valor
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue", "class"]),
                      _withDirectives(_createElementVNode("div", _hoisted_13, null, 512), [
                        [_vShow, !_ctx.validacionInfoRepresentanteTitular.RLTitular.$each.$response.$errors[scope.$index].VinculosFamPEP_RLTitular.length]
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoRepresentanteTitular.RLTitular.$each.$response.$errors[scope.$index].VinculosFamPEP_RLTitular, (error) => {
                        return (_openBlock(), _createBlock(_component_el_form_item, {
                          key: error,
                          class: "section-error-message"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(error.$message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, { width: "50" }, {
                    default: _withCtx((scope) => [
                      (scope.$index > 0)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            circle: "",
                            class: "dinamic-form-button",
                            size: "small",
                            type: "success",
                            icon: "el-icon-minus",
                            onClick: ($event: any) => {_ctx.EliminarFilaRLTitular(scope.$index);_ctx.ValidaSiPEP();}
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      _hoisted_14
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                circle: "",
                class: "dinamic-form-button",
                size: "small",
                type: "success",
                icon: "el-icon-plus",
                onClick: _ctx.AgregarFilaRLTitular
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}